import axios from 'axios';
import conf from './conf';
import businessUser from '../config/businessUser';
import {
  Toast
} from 'mint-ui';

var VUE = null
const HOST = ''; //conf.HOSTS.LOCAL; //conf.HOSTS.IT4

const httpAxios = axios.create({
  baseURL: `${HOST}/api/local/v1`,
  timeout: conf.TIMEOUT,
});
// httpAxios.interceptors.request.use(...interceptorsRequest);
httpAxios.interceptors.response.use(function (res) {
    res.config = res.config || {};
    let errorMsg = res.data.error || res.data.Toast || ''
    res.data = res.data || {}
    res.data._meta = res.config.params || {} // 请求信息
    if (!res.data.success) {
      res.data.error = true
      Toast(errorMsg || '网络错误，请稍后重试')
    }
    return res.data;
  },
  function (err = {}) {
    Toast((err.toString && err.toString()) || '网络错误，请稍后重试');
    return Promise.resolve({
      error: true,
      _err: err
    })
  }
);

const API = {
  /**
   * 州列表
   */
  getStateList(params) {
    return httpAxios.get('/business/get-state-list');
  },
  // 城市 -- 具体城市
  getCounties(params) {
    return httpAxios.get('/business/get-county-list', {
      params
    })
  },
  getCategory(params) {
    return httpAxios.get(`/business/get-category-list?cityId=${params.cityId}`)
  },
  // get-service-tags
  getServiceTags(params) {
    return httpAxios.get(`/business/get-service-tags`);
  },
  /**
   * record-info
   */
  saveBusinessInfo(params) {
    return httpAxios.post(`/business/record-info`, params);
  },
  getUserList() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          data: businessUser
        });
      }, 100);
    })
  }
}

export default (Vue) => {
  VUE = Vue;
  VUE.prototype.$utils.extend(VUE.prototype.$api, API);
}



// WEBPACK FOOTER //
// ./src/api/business.js